/** @jsx isolateComponent */

import { css } from '@emotion/core';

import { FancyPrice } from '@zapier/currency';
import { Colors, Spacer, Text } from '@zapier/design-system';
import { isolateComponent } from '@zapier/style-encapsulation';

import { Currency, Plan } from '@zapier/upsells/src/types';

const styles = {
  divider: css`
    background-color: ${Colors.gray20};
    border-radius: 5px;
    height: 3px;
    width: 40px;
  `,
  root: (hasBorder: boolean) => css`
    background: ${Colors.gray5};
    border: ${hasBorder ? `3px solid ${Colors.ocean}` : 0};
    border-radius: 10px;
    margin: 0 auto;
    padding: 20px;
    width: 250px;
  `,
  tasksDisplay: css`
    background: ${Colors.gray10};
    border-radius: 10px;
    padding: 10px 15px;
  `,
};

type Props = {
  currency: Currency;
  hasBorder?: boolean;
  plan: Plan;
  title: string;
};

export const PlanCard = ({
  currency,
  hasBorder = false,
  plan,
  title,
}: Props) => {
  /**
   * Only monthly-billed plans are eligible for auto-upgrade, so this component
   * makes that assumption in a few places.
   */
  return (
    <div css={styles.root(hasBorder)}>
      <Text fontWeight={400} type="superTitle3">
        {title}
      </Text>

      <Spacer height={5} />

      <FancyPrice currency={currency}>{plan.amount}</FancyPrice>

      <Spacer height={5} />

      <Text color="gray60" type="smallPrint1">
        per month, billed monthly
      </Text>

      <Spacer height={25} />

      <div css={styles.divider} />

      <Spacer height={10} />

      <Text tag="p" type="sectionHeader3">
        {plan.type}
      </Text>

      <Spacer height={20} />

      <div css={styles.tasksDisplay}>
        <Text tag="p" type="smallPrint1">
          <strong>{Number(plan.tasks).toLocaleString()} Tasks</strong> /mo
        </Text>
      </div>
    </div>
  );
};
